export interface InsightSection {
  heading: string;
  paragraphs: string[];
}

export interface Insight {
  _id: string;
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  author: string;
  readMins: number;
  date: string;
  heroImage?: string;
  sections: InsightSection[];
  takeaways: string[];
  disclaimer: string;
  featured: boolean;
  status: 'draft' | 'published';
  createdAt?: string;
}

export interface InsightFormData {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  author: string;
  readMins: number;
  date: string;
  heroImage: string;
  sections: InsightSection[];
  takeaways: string[];
  disclaimer: string;
  featured: boolean;
  status: 'draft' | 'published';
}

export const INSIGHT_CATEGORIES = [
  'Market',
  'Structuring',
  'Outlook',
  'Data',
  'Regulation',
  'Product',
];
